export default __webpack_public_path__ + "static/media/01_standard.5883d309.png";